import { getImagePath } from "../common/productImageUtils";
import { SpecificDurationDropDown } from "../pages/add-edit-product/StaticData";

export const showVariantTypeSlider = payload => ({
	type: 'SHOW_VARIANT_TYPE_SLIDER',
	payload
});

export const showVariantOptionsSlider = payload => ({
	type: 'SHOW_VARIANT_OPTIONS_SLIDER',
	payload
});

export const showEditVariantSlider = payload => ({
	type: 'SHOW_EDIT_VARIANT_SLIDER',
	payload
});

export const setVariantData = payload => ({
	type: 'SET_VARIANT_DATA',
	payload
});

export const showVariantDetailsSlider = payload => ({
	type: 'SHOW_VARIANT_DETAILS_SLIDER',
	payload
})

export const validateVariants = (variants) => (dispatch, getState) => {
	//Need to do
	const state = getState();
	let skuIds = [];
	let variantData = [...(variants?variants:state.variants.variantProductData)];
	let errorMsg = '';
	state.session.viaOmni && variantData.map((cur,index) => {
		let errors = {...cur.errors};
		if(Number(cur['quantity']) > 100) {
			errorMsg = 'Qty Cannot be More than 100';
			errors['quantity'] = 'Cannot be More than 100';
		}
		cur.errors = errors;
	})
	variantData.map((cur,index) => {
		let qty = cur['quantity'];
		let sp = cur['sp'];
		let mrp = cur['mrp'];
		let errors = {...cur.errors};
		let sku = cur['sku'];
		if(!state.session?.viaOmni &&  !(cur['imageUrlArr'].length || !cur.hasOwnProperty('imageUrlArr'))){
            errors['imageUrlArr'] = true;
            errorMsg = errorMsg?errorMsg:'Please upload product image';
        }
        if(!state.session?.viaOmni && !qty){
            errors['quantity'] = 'Please Enter Qty';
            errorMsg = errorMsg?errorMsg:'Please Enter Quantity';
        }
		if(!state.session?.viaOmni &&  Number(qty) == 0){
			errors['quantity'] = "Qty can't be Zero";
			errorMsg = errorMsg?errorMsg:"Qty can't be Zero";
		}else if (Number(qty) > 100) {
			errors['quantity'] = 'Quantity Cannot be More than 100';
			errorMsg = errorMsg ? errorMsg : 'Quantity Cannot be More than 100';
		}
		if(Number(sp) > Number(mrp) && !errors['quantity']){
			errors['sp'] = mrp?'Higher than MRP':true;
            errorMsg = errorMsg?errorMsg:'Selling Price cannot be greater than MRP';
		}
        if(!mrp && !state.session?.viaOmni) {
            if(errors['quantity'] && !qty) {
                errors['quantity'] = 'Please Enter Qty	 & Price';
                errors['mrp'] = true;
                errorMsg = errorMsg?errorMsg:'Please Enter Quantity & Price';
            }else if(qty && qty != 0) {
                errors['mrp'] = 'Please Enter MRP';
                errorMsg = errorMsg?errorMsg:'Please Enter MRP';
            }else if(qty == '0'){
				errors['mrp'] = true;
			}
        }
		if(mrp && Number(mrp) == 0){
			errors['mrp'] = errorMsg && errors['quantity']?true:"MRP cannot be 0";
			errorMsg = errorMsg?errorMsg:"MRP cannot be 0";
		}else if(mrp &&  Number(mrp) < 0.01){
			errors['mrp'] = errorMsg && errors['quantity']?true:"MRP must be at least 0.01";
			errorMsg = errorMsg?errorMsg:"MRP must be at least 0.01";
		}
        if(!sp && !state.session?.viaOmni) {
            errors['sp'] = errorMsg?true:'Please Enter SP';
            errorMsg = errorMsg?errorMsg:'Please Enter SP';
        }
		if(sp && Number(sp) == 0){
			errors['sp'] = errorMsg && (errors['quantity'] || errors['mrp'])?true:"SP cannot be 0";
			errorMsg = errorMsg?errorMsg:"SP cannot be 0";
		}else if(sp && Number(sp) < 0.01){
			errors['sp'] = errorMsg && (errors['quantity'] || errors['mrp'])?true:"SP must be at least 0.01";
			errorMsg = errorMsg?errorMsg:"SP must be at least 0.01";
		}
		if(!state.session?.viaOmni && skuIds.includes(sku) && sku){
			let skuErrIndex = variantData.findIndex(el => el['sku'] === sku);
			errors['sku'] = true;
			errorMsg = errorMsg?errorMsg:"This Seller SKU ID Already Exists	In Another Variant";
			variantData[skuErrIndex].errors = {...variantData[skuErrIndex].errors,sku: true}
		}else if(sku) {
			skuIds.push(sku);
		}
		cur.errors = errors;
	})
	!variants && dispatch({
		type: 'SET_VARIANT_PRODUCT_DATA',
		payload: variantData
	})
	return  {
		errorMsg,
		variants: variants?variantData:''
	}

}

export const validateVariantsService = (variants,err={}) => (dispatch,getState) => {
	let state = getState();
	let variantData = [...(variants?variants:state.variants.variantProductData)];
	let isSpecificTime = state.products.editProduct.unitOfMeasurement == 'stds';
	let errorMsg = '';
	variantData.map((cur,index) => {
		let errors = {...cur.errors};
		let actualPrice = cur['actualPrice'];
		let discPrice = cur['discPrice'];
		if(!cur['isChanged'] || (!actualPrice && !discPrice)) {
			return;
		}
		if(isSpecificTime) {
			if(!Number(cur['specificDuration'])) {
				errors['specific'] = 'Please Enter Valid Value';
				errorMsg = errorMsg ? errorMsg : 'Please Enter Valid Value';
			}
		}
		if(actualPrice && Number(actualPrice) == 0) {
			errors['actualPrice'] = 'Actual Rs. Cannot be 0';
			errorMsg = errorMsg ? errorMsg : 'Actual Rs. Cannot be 0';
		}else if(actualPrice && Number(actualPrice) < 0.01) {
			errors['actualPrice'] = 'Actual Rs. must be at least 0.01';
			errorMsg = errorMsg ? errorMsg : 'Actual Rs. must be at least 0.01';
		}
		if(discPrice && Number(discPrice) == 0) {
			errors['discPrice'] = errorMsg && errors['actualPrice'] ? true : 'Discounted Rs. Cannot be 0';
			errorMsg = errorMsg ? errorMsg : 'Discounted Rs. Cannot be 0';
		}else if(discPrice && Number(discPrice) < 0.01) {
			errors['discPrice'] = errorMsg && errors['actualPrice'] ? true : 'Discounted Rs. must be at least 0.01'
			errorMsg = errorMsg ? errorMsg : 'Discounted Rs. must be at least 0.01';
		}

		if(actualPrice && Number(actualPrice) < Number(discPrice) && !(errors['actualPrice'] && errors['discPrice'])) {
			errors['discPrice'] = errorMsg ? errorMsg : 'Discounted Rs. Cannot be More than Actual Rs.';
			// errors['discPrice'] = true;
			errorMsg = errorMsg ? errorMsg : 'Discounted Rs. Cannot be More than Actual Rs.';
		}
		if (err?.err?.status == 3){
			if (actualPrice && (Number(actualPrice) < Number(err.err.priceRange.minPrice)) || (Number(actualPrice) > Number(err.err.priceRange.maxPrice))){
				errors['actualPrice'] = err.err.msg || '';
			}
			if (discPrice && (Number(discPrice) < Number(err.err.priceRange.minPrice)) || (Number(discPrice) > Number(err.err.priceRange.maxPrice))){
				errors['discPrice'] = err.err.msg || '';
			}
		}
		cur.errors = errors;
	})
	!variants && dispatch({
		type: 'SET_VARIANT_PRODUCT_DATA',
		payload: variantData
	})
	return  {
		errorMsg,
		variants: variants?variantData:''
	}
}

export const getVariantFlags = arr => {
	if(arr.length == 0){
		return {noOfVariants: 0, colorPresent: false}
	}
	let noOfVariants = 1;
	let colorPresent = false
	for(let i=0;i<arr.length;i++){
		if(arr[i].type.toLowerCase() == 'color' || arr[i].type.toLowerCase() == 'colour' || arr[i].type.toLowerCase() == 'colors'){
			colorPresent = true;
		}
		noOfVariants = noOfVariants * arr[i].options.length;
	}

	return {noOfVariants, colorPresent};
}

export const createVariantCombinations = (arr, isEdit) => (dispatch, getState) => {
	if(arr.length == 0){
		dispatch({
			type: 'SET_VARIANT_COMBINATIONS',
			payload: []
		})
		return;
	}
	let result = [], max = arr.length-1;
	let oldCombinations = getState().variants.variantCommand?.variantCombinations || [] //Used in Edit Scenario
	function makeCombinations(item, i, isNew) {
        for (let j=0, l=arr[i].options.length; j<l; j++) {
			if(isEdit){
				isNew = isNew ? isNew : !arr[i].nonEditable[j];
			}
            var a = item.slice(0);
			a.push({[arr[i].type]: arr[i].options[j]});

            if (i==max){
				if(!isEdit || isNew){
					result.push(a);
				}
			}else{
				makeCombinations(a, i+1, isNew);
			}
        }
    }
	makeCombinations([], 0, false);
	if(isEdit){
		result = [...oldCombinations, ...result];
	}
	dispatch({
		type: 'SET_VARIANT_COMBINATIONS',
		payload: result
	})
}

export const setVariantProductData = payload => ({
	type: 'SET_VARIANT_PRODUCT_DATA',
	payload
})
export const setVariantCorrection = payload => ({
	type : 'SET_VARIANT_CORRECTION',
	payload
})

export const showMoreDetailsSlider = payload => ({
	type: 'SHOW_MORE_DETAILS_SLIDER',
	payload
})

export const setSyncImages = payload => ({
	type: 'SET_SYNC_IMAGES',
	payload
})

export const resetVariantData = () => ({
	type: 'RESET_VARIANT_DATA',
})

export const showSyncImagesModal = payload => ({
	type: 'SHOW_SYNC_IMAGES_MODAL',
	payload
})

export const showSettingsSlider = payload => ({
	type: 'SHOW_SETTINGS_SLIDER',
	payload
})

export const deleteAllImages = (prodArr) => dispatch => {
	prodArr = [...prodArr];
	for(let i=0;i<prodArr.length;i++){
		prodArr[i].imageUrlArr = [];
	}
	dispatch({
		type: 'SET_VARIANT_PRODUCT_DATA',
		payload: prodArr
	});
}

export const syncImageUpload = (prodArr, typeInfo, index) => {
	prodArr = [...prodArr]

	let color = '';
	let typeIndex = '';
	typeInfo[index].map((item, index)=>{
		if(Object.keys(item)[0].toLowerCase() == 'color' || Object.keys(item)[0].toLowerCase() == 'colour' || Object.keys(item)[0].toLowerCase() == 'colors' ){
			color = item[Object.keys(item)[0]];
			typeIndex = index;
		}
	})
	const imageUrlArr = prodArr[index].imageUrlArr;
	const videoUrlArr = prodArr[index].videoUrlArr;
	for(let i=0;i<prodArr.length;i++){
		const prodColor = typeInfo[i][typeIndex][Object.keys(typeInfo[i][typeIndex])[0]]
		if(color == prodColor){
			prodArr[i].imageUrlArr = [...imageUrlArr],
			prodArr[i].videoUrlArr = [...videoUrlArr]
		}
	}
	return prodArr
}

export const formatVariantForObjection = (data,videoLibrary,productData) => {
	let {
		variantJson,
		variantsInventoryJson
	} = data;
	variantJson = JSON.parse(variantJson);
	variantsInventoryJson = JSON.parse(variantsInventoryJson);
	let variantCommands = [];
	variantJson.map((cur,index) => {
		let variant = {
			imageUrl: cur.productImage,
			totalQuantity: variantsInventoryJson[index].newQuantity,
			isActive: cur.isActive,
			videoUrlIds: cur.videoUrlIds
		}
		variant.list = cur.customAttributeValues.map(el => {
			let items = el.split(';');
			return {
				key: items[0],
				value: items[1]
			}
		})
		variant.consignmentCommand = {
			productName: "",
			quantity: variantsInventoryJson[index].newQuantity,
			sellingPrice: variantsInventoryJson[index].newsellingPrice,
			mrp: variantsInventoryJson[index].newmrp,
			sku: variantsInventoryJson[index].newSku,
			productId: cur.productId,
			newactualPrice: variantsInventoryJson[index].newactualPrice,
			newdiscPrice: variantsInventoryJson[index].newdiscPrice,
		}

		const value = cur.unit_of_measurement ? cur.unit_of_measurement.split(" ") : [];
		if(value.length > 1){
			variant.customDuration = Number(value[0])
			variant.customUnit = value[1]
			variant.uom = value
		}else{
			variant.unitOfMeasurement = value[0]
		}

		variantCommands.push(variant);
	})
	if(productData.categoryType === "service"){
		const value = variantJson[0].unit_of_measurement.split(" ")
		if(value.length > 1){
			const stds = SpecificDurationDropDown.find(item=>item.key === value[1])
			if(stds?.key){
				productData.unitOfMeasurement = "stds"
			}else{
				productData.unitOfMeasurement = value[1]
			}
		}else{
			productData.unitOfMeasurement = value[0]
		}
	}
	return formatVariantData(variantCommands,videoLibrary,"",productData.unitOfMeasurement);
	const getVideoObj = (id) => {
		if(videoLibrary && videoLibrary[id]){
			return [JSON.parse(JSON.stringify(videoLibrary[id]))]
		}else{
			return []
		}
	}
	let resultData = [];
	let curData = {};
	variantJson.map((cur,index) => {
		curData.imageUrl = cur.productImage.split(',');

	})

	console.log('Pending Handling')
}

export const formatVariantData = (arr, videoLibrary, isDuplicate, unitOfMeasurement,viaOmni=false) => {
	let variantProductData = [];
	let variantData = [];
	let variantCombinations = [];

	let typesAdded = [];
	let optionsAdded = {};
	let nonEditable = {};

	const getVideoObj = (id) => {
		if(videoLibrary && videoLibrary[id]){
			return [JSON.parse(JSON.stringify({...videoLibrary[id],videoId: id}))]
		}else{
			return []
		}
	}
	for(let i =0;i<arr.length;i++){
		let imageUrlArr = [];
		variantCombinations[i] = [];
		for(let j=0;j<arr[i].list.length;j++){
			let variantTypeObj = arr[i].list[j];
			if(typesAdded.indexOf(variantTypeObj.key) == -1){
				typesAdded.push(variantTypeObj.key)
			}
			if(!optionsAdded[variantTypeObj.key]){
				optionsAdded[variantTypeObj.key] = [variantTypeObj.value]
				nonEditable[variantTypeObj.key] = [true]
			}else if(optionsAdded[variantTypeObj.key].indexOf(variantTypeObj.value) == -1){
				optionsAdded[variantTypeObj.key].push(variantTypeObj.value);
				nonEditable[variantTypeObj.key].push(true)
			}
			variantCombinations[i][j] = {
				[variantTypeObj.key]: variantTypeObj.value
			}
		}
		if(arr[i]['imageUrl']) {
			imageUrlArr = arr[i]['imageUrl'].split(',').map(cur => ({
				imageURL: cur,
				actualPath: getImagePath(cur),
				uploaded: true
			}));
		}
		// for(let j=0;j<40;j++){
		// 	if(!arr[i]['productImage'+(j+1)]){
		// 		break;
		// 	}
		// 	imageUrlArr[j] = {
		// 		imageURL: arr[i]['productImage'+(j+1)],
		// 		actualPath: getImagePath(arr[i]['productImage'+(j+1)]),
		// 		uploaded: true
		// 	}
		// }
		variantProductData[i] = {
			variantId: arr[i].consignmentCommand.productId,
			imageUrlArr: imageUrlArr,
			videoUrlArr: arr[i].videoUrlIds?.length ? getVideoObj(arr[i].videoUrlIds[0]) : [], //Add key after handling from backend
			quantity: isDuplicate?'':arr[i].consignmentCommand?.quantity,
			mrp: arr[i].consignmentCommand?.mrp ? Number(arr[i].consignmentCommand?.mrp) : 0,
			sp: arr[i].consignmentCommand?.sellingPrice ? Number(arr[i].consignmentCommand?.sellingPrice) : 0,
			cp: arr[i].consignmentCommand?.costPrice ? Number(arr[i].consignmentCommand?.costPrice) : 0,
			actualPrice: arr[i].consignmentCommand?.newactualPrice && arr[i].consignmentCommand?.newactualPrice != 0 ? Number(arr[i].consignmentCommand?.newactualPrice) : '',
			discPrice: arr[i].consignmentCommand?.newdiscPrice && arr[i].consignmentCommand?.newdiscPrice != 0 ? Number(arr[i].consignmentCommand?.newdiscPrice) : '',
			barcode: arr[i].consignmentCommand?.barcode,
			sku: arr[i].consignmentCommand?.sku,
			showOnWebsite: arr[i].isActive,
			batch: arr[i].consignmentCommand?.consignment_no_display,
			isApplicableExpDate: (arr[i].consignmentCommand?.manufacturingDate || arr[i].consignmentCommand?.expiryDate) ? true : false,
			bestBefore: arr[i].consignmentCommand?.bestBefore ? arr[i].consignmentCommand?.bestBefore.split('-')[0] : "",
			bestBeforeUnit: arr[i].consignmentCommand?.bestBefore ? arr[i].consignmentCommand?.bestBefore.split('-')[1] : "months",
			isAutoReorderLevel: arr[i].isAutoReorderLevel,
			isAutoReorderQuantity: arr[i].isAutoReorderQuantity,
			reorderLevel: arr[i].reorderLevel ? arr[i].reorderLevel : 0,
			reorderQuantity: arr[i].reorderQuantity ? arr[i].reorderQuantity : 0,
			customDuration: arr[i].customDuration ? arr[i].customDuration : '',
			specificDuration: unitOfMeasurement == 'stds' ? arr[i].customDuration : '',
			specificDurationUnit: unitOfMeasurement == 'stds' ? arr[i].customUnit : '',
			errors: {},
			warnings: {}
		}
		if (arr[i].consignmentCommand.manufacturingDate) {
			let tempDateObj = arr[i].consignmentCommand.manufacturingDate.split('T')[0];
			let manufDate = tempDateObj.split('-').reverse();
			variantProductData[i].manufacturingDate = manufDate.join('/');
			if(!arr[i].consignmentCommand.expiryDate && !viaOmni) {
				variantProductData[i].expiryDate = variantProductData[i].manufacturingDate; //for bug #257123
			}
		} 
		if (arr[i].consignmentCommand.expiryDate) {
			let tempDateObj = arr[i].consignmentCommand.expiryDate.split('T')[0];
			let expiryDate = tempDateObj.split('-').reverse();
			variantProductData[i].expiryDate = expiryDate.join('/');
			if(!arr[i].consignmentCommand.manufacturingDate && !viaOmni) {
				variantProductData[i].manufacturingDate = variantProductData[i].expiryDate; //for bug #257123
			}
		}
		if(viaOmni){				
			if(variantProductData[i]?.expiryDate) {
				variantProductData[i]['expiryBy'] = 'expiryDate';
			} else {
				variantProductData[i]['expiryBy'] = 'manufacturingDate';
			}
		}

		variantProductData[i].batchCount = arr[i].hasOwnProperty('batchCount') ? arr[i].batchCount : 0;
	}
	for(let i=0;i<typesAdded.length;i++){
		variantData.push({
			type: typesAdded[i],
			options: optionsAdded[typesAdded[i]],
			nonEditable: nonEditable[typesAdded[i]]
		})
	}
	return{
		variantCombinations,
		variantData,
		variantProductData,
		variantCommand: {apiData: arr, variantCombinations: variantCombinations}
	}
}